import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';

import authSlice from './slices/authSlice';
import uiSlice from './slices/uiSlice';

/**
 * 持久化配置
 * whitelist: 需要持久化的 reducer
 */
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

// 合并所有 reducer
const rootReducer = combineReducers({
  auth: authSlice,
  ui: uiSlice,
});

// 创建持久化 reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 配置 store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);
export default store;
